document.addEventListener('DOMContentLoaded', function () {
  /* ================= HEADER ================= */
  var header = document.getElementById('FengHeader');
  var hoverBg = document.getElementById('HoverBg');
  if (header && hoverBg) {
    var hoverTimeout;
    document.querySelectorAll('.feng-nav-item').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(hoverTimeout);
        if (item.classList.contains('has-dropdown')) {
          header.classList.add('is-hovered');
          var dropdown = item.querySelector('.feng-nav-dropdown');
          requestAnimationFrame(function () {
            hoverBg.style.height = (header.offsetHeight + dropdown.offsetHeight) + 'px';
          });
        } else {
          hoverBg.style.height = '0';
          header.classList.remove('is-hovered');
        }
      });
      item.addEventListener('mouseleave', function () {
        hoverTimeout = setTimeout(function () {
          hoverBg.style.height = '0';
          header.classList.remove('is-hovered');
        }, 50);
      });
    });

    var isCollectionPage = !!document.getElementById('FengCollectionBar');
    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    window.addEventListener('scroll', function () {
      if (!isCollectionPage) return;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop && scrollTop > 80) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }, false);
  }

  /* ================= MOBILE DRAWER ================= */
  var drawer = document.getElementById('FengMobileDrawer');
  var btnOpen = document.getElementById('FengMenuToggle');
  var btnClose = document.getElementById('FengMenuClose');
  var level1 = document.getElementById('DrawerLevel1');
  if (drawer && btnOpen && btnClose && level1) {
    btnOpen.addEventListener('click', function () { drawer.classList.add('is-open'); });
    btnClose.addEventListener('click', function () {
      drawer.classList.remove('is-open');
      setTimeout(function () {
        level1.classList.remove('is-shifted');
        document.querySelectorAll('.drawer-level-2').forEach(function (s) { s.classList.remove('is-active'); });
      }, 400);
    });
    document.querySelectorAll('.drawer-btn[data-target]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        level1.classList.add('is-shifted');
        document.getElementById(this.getAttribute('data-target')).classList.add('is-active');
      });
    });
    document.querySelectorAll('.drawer-back-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        this.parentElement.classList.remove('is-active');
        level1.classList.remove('is-shifted');
      });
    });
  }

  /* ================= COLLECTION / SEARCH ================= */
  var collBar = document.getElementById('FengCollectionBar');
  if (collBar) {
    var lastTop = window.pageYOffset || document.documentElement.scrollTop;
    var headerHeight = header ? header.offsetHeight : 90;
    collBar.style.top = headerHeight + 'px';
    window.addEventListener('scroll', function () {
      var st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > lastTop && st > 50) collBar.style.top = '0px';
      else { headerHeight = header ? header.offsetHeight : 90; collBar.style.top = headerHeight + 'px'; }
      lastTop = st <= 0 ? 0 : st;
    }, false);
  }

  var productGrid = document.getElementById('FengGrid');
  function toggle(btnOn, btnOff, cls, add) {
    if (!btnOn || !btnOff || !productGrid) return;
    btnOn.addEventListener('click', function (e) {
      e.preventDefault();
      productGrid.classList[add ? 'add' : 'remove'](cls);
      btnOn.classList.add('is-active');
      btnOff.classList.remove('is-active');
    });
  }
  var btnModel = document.getElementById('BtnModel'), btnItems = document.getElementById('BtnItems');
  toggle(btnModel, btnItems, 'is-model-view', true);
  toggle(btnItems, btnModel, 'is-model-view', false);
  var btnCol3 = document.getElementById('BtnCol3'), btnCol5 = document.getElementById('BtnCol5');
  toggle(btnCol5, btnCol3, 'is-col-5', true);
  toggle(btnCol3, btnCol5, 'is-col-5', false);
  var btnMCol2 = document.getElementById('BtnMCol2'), btnMCol1 = document.getElementById('BtnMCol1');
  toggle(btnMCol1, btnMCol2, 'is-col-1', true);
  toggle(btnMCol2, btnMCol1, 'is-col-1', false);

  var loadMoreTrigger = document.getElementById('FengLoadMore');
  if (loadMoreTrigger && productGrid) {
    var isFetching = false;
    var cardSelector = productGrid.classList.contains('feng-erd-grid') ? '.feng-erd-card' : '.feng-product-card';
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !isFetching) fetchNextPage();
    }, { rootMargin: '0px 0px 600px 0px' });
    observer.observe(loadMoreTrigger);
    function fetchNextPage() {
      var nextUrl = loadMoreTrigger.getAttribute('data-url');
      if (!nextUrl) return;
      isFetching = true;
      fetch(nextUrl).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll(cardSelector).forEach(function (p) { productGrid.insertBefore(p, loadMoreTrigger); });
        var newTrigger = doc.getElementById('FengLoadMore');
        if (newTrigger && newTrigger.getAttribute('data-url')) loadMoreTrigger.setAttribute('data-url', newTrigger.getAttribute('data-url'));
        else { loadMoreTrigger.removeAttribute('data-url'); observer.disconnect(); }
        isFetching = false;
      }).catch(function () { isFetching = false; });
    }
  }

  var searchForm = document.querySelector('.feng-search-form-brutalist');
  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      var inp = this.querySelector('input[name="q"]');
      if (inp.value.indexOf('script') > -1 || inp.value.indexOf('>') > -1) { e.preventDefault(); inp.value = ''; }
    });
  }

  /* ================= PRODUCT ================= */
  var sizeSelector = document.getElementById('FengSizeSelector');
  if (sizeSelector) {
    var cfg = window.FengProduct || {};
    var priceDisplay = document.getElementById('FengProductPrice');
    var atcBtn = document.getElementById('AddToCart');
    var hiddenSelect = document.getElementById('ProductSelect');
    var sizeBtns = sizeSelector.querySelectorAll('.feng-size-btn');
    var waitlistWrap = document.getElementById('WaitlistWrap');
    var waitlistTags = document.getElementById('WaitlistTags');
    var waitlistSizeLabel = document.getElementById('WaitlistSizeLabel');

    function applyVariant(btn) {
      sizeBtns.forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var variantId = btn.getAttribute('data-variant-id');
      var variantTitle = btn.getAttribute('data-variant-title');
      var isAvailable = btn.getAttribute('data-available') === 'true';
      var currentPrice = btn.getAttribute('data-variant-price');
      var comparePrice = btn.getAttribute('data-variant-compare');
      var rawBasePrice = btn.getAttribute('data-base-price');
      if (hiddenSelect) hiddenSelect.value = variantId;
      if (priceDisplay) {
        priceDisplay.removeAttribute('data-geo-applied');
        if (rawBasePrice) priceDisplay.setAttribute('data-base-price', rawBasePrice);
        if (comparePrice) priceDisplay.innerHTML = '<span class="feng-compare">' + comparePrice + '</span><span class="feng-sale">' + currentPrice + '</span>';
        else priceDisplay.textContent = currentPrice;
      }
      if (waitlistSizeLabel) waitlistSizeLabel.textContent = variantTitle;
      if (waitlistTags) waitlistTags.value = (cfg.comingSoon ? 'ComingSoon, ' : '') + 'Waitlist, Waitlist_' + cfg.handle + ', Size_' + variantTitle;
      if (cfg.comingSoon) {
        if (atcBtn) { atcBtn.type = 'button'; atcBtn.disabled = true; atcBtn.textContent = 'COMING SOON'; }
        if (waitlistWrap) { waitlistWrap.style.display = 'block'; waitlistWrap.classList.add('is-coming-soon'); }
      } else if (cfg.preOrder) {
        if (atcBtn) { atcBtn.type = 'submit'; atcBtn.disabled = false; atcBtn.textContent = 'PRE-ORDER'; }
        if (waitlistWrap) waitlistWrap.style.display = 'none';
      } else if (isAvailable) {
        if (atcBtn) { atcBtn.type = 'submit'; atcBtn.disabled = false; atcBtn.textContent = 'ADD TO CART'; }
        if (waitlistWrap) waitlistWrap.style.display = 'none';
      } else {
        if (atcBtn) { atcBtn.type = 'button'; atcBtn.disabled = true; atcBtn.textContent = 'SOLD OUT'; }
        if (waitlistWrap) { waitlistWrap.style.display = 'block'; waitlistWrap.classList.remove('is-coming-soon'); }
      }
    }
    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); applyVariant(this); });
    });
    var initial = sizeSelector.querySelector('.feng-size-btn.is-selected') || sizeBtns[0];
    if (initial) applyVariant(initial);

    var btnGuide = document.getElementById('BtnSizeGuide');
    var modalGuide = document.getElementById('ModalSizeGuide');
    var closeGuide = document.getElementById('CloseSizeGuide');
    if (btnGuide && modalGuide) {
      btnGuide.addEventListener('click', function (e) { e.preventDefault(); modalGuide.classList.add('is-active'); document.body.style.overflow = 'hidden'; });
      closeGuide.addEventListener('click', function () { modalGuide.classList.remove('is-active'); document.body.style.overflow = ''; });
      modalGuide.addEventListener('click', function (e) { if (e.target === modalGuide) { modalGuide.classList.remove('is-active'); document.body.style.overflow = ''; } });
    }

    var imageContainer = document.getElementById('FengImageContainer');
    if (imageContainer && window.innerWidth >= 1025) {
      imageContainer.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { e.preventDefault(); this.scrollLeft += e.deltaY; }
      }, { passive: false });
    }

    function panImage(e, img) {
      var rect = img.parentElement.getBoundingClientRect();
      var x = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
      var y = Math.max(0, Math.min(e.clientY - rect.top, rect.height));
      img.style.transformOrigin = (x / rect.width * 100) + '% ' + (y / rect.height * 100) + '%';
    }
    document.querySelectorAll('.feng-zoomable-image img').forEach(function (img) {
      var isZoomed = false;
      img.addEventListener('click', function (e) {
        if (window.innerWidth < 1025) return;
        isZoomed = !isZoomed;
        if (isZoomed) { this.classList.add('is-zoomed'); panImage(e, this); }
        else { this.classList.remove('is-zoomed'); this.style.transformOrigin = 'center center'; }
      });
      img.addEventListener('mousemove', function (e) { if (isZoomed && window.innerWidth >= 1025) panImage(e, this); });
      img.addEventListener('mouseleave', function () {
        if (isZoomed && window.innerWidth >= 1025) { isZoomed = false; this.classList.remove('is-zoomed'); this.style.transformOrigin = 'center center'; }
      });
    });

    if (cfg.handle) {
      var currentProduct = { handle: cfg.handle, title: cfg.title, url: cfg.url, image: cfg.image, price: cfg.price };
      var recent = [];
      try { recent = JSON.parse(localStorage.getItem('feng_recently_viewed') || '[]'); } catch (err) {}
      var rvWrapper = document.getElementById('FengRVWrapper');
      var rvGrid = document.getElementById('FengRVGrid');
      var items = recent.filter(function (i) { return i.handle !== currentProduct.handle; });
      if (items.length && rvGrid && rvWrapper) {
        rvGrid.innerHTML = items.map(function (item) {
          return '<a href="' + item.url + '" class="feng-rv-card"><div class="feng-rv-img-wrap"><img src="' + item.image + '" alt="' + item.title + '"></div>' +
            '<div class="feng-rv-info"><div class="feng-rv-product-name">' + item.title + '</div><div class="feng-rv-product-price product-price">' + item.price + '</div></div></a>';
        }).join('');
        rvWrapper.style.display = 'block';
      }
      items.unshift(currentProduct);
      if (items.length > 4) items.pop();
      try { localStorage.setItem('feng_recently_viewed', JSON.stringify(items)); } catch (err) {}
    }
  }

  /* ================= CART ================= */
  var cartForm = document.getElementById('cartformpage');
  if (cartForm) {
    cartForm.querySelectorAll('.qtyplus').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var input = this.parentElement.querySelector('input');
        input.value = parseInt(input.value, 10) + 1;
        cartForm.submit();
      });
    });
    cartForm.querySelectorAll('.qtyminus').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var input = this.parentElement.querySelector('input');
        if (parseInt(input.value, 10) > 1) { input.value = parseInt(input.value, 10) - 1; cartForm.submit(); }
      });
    });
    var overlay = document.getElementById('FengPaymentOverlay');
    var termsBox = document.getElementById('chk_terms');
    var termsErr = document.getElementById('terms_error_msg');
    function closePay() { if (overlay) overlay.classList.remove('is-active'); document.body.style.overflow = ''; }
    var btnCheckout = document.getElementById('btnCart-checkout');
    if (btnCheckout) btnCheckout.addEventListener('click', function (e) {
      e.preventDefault();
      if (termsBox && !termsBox.checked) {
        if (termsErr) { termsErr.classList.add('is-visible'); window.scrollTo({ top: termsErr.getBoundingClientRect().top + window.pageYOffset - 180, behavior: 'smooth' }); }
        return;
      }
      if (termsErr) termsErr.classList.remove('is-visible');
      if (overlay) { overlay.classList.add('is-active'); document.body.style.overflow = 'hidden'; }
      else document.getElementById('checkout').click();
    });
    var proceed = document.getElementById('FengPaymentProceedBtn');
    if (proceed) proceed.addEventListener('click', function (e) { e.preventDefault(); closePay(); document.getElementById('checkout').click(); });
    var payClose = document.getElementById('FengPaymentCloseBtn');
    if (payClose) payClose.addEventListener('click', function (e) { e.preventDefault(); closePay(); });
    if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) closePay(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && overlay.classList.contains('is-active')) closePay(); });
  }

  /* ================= ARCHIVE (sticky stack snap) ================= */
  var stack = document.querySelector('.feng-archive-stack');
  if (stack && window.innerWidth >= 992) {
    var isScrolling = false;
    window.addEventListener('wheel', function (e) {
      var layers = document.querySelectorAll('.feng-archive-layer');
      var maxLayerIndex = layers.length - 1;
      var vh = window.innerHeight;
      var cur = window.scrollY;
      var maxScroll = document.body.scrollHeight - vh;
      var lastLayerScroll = maxLayerIndex * vh;
      var dir = e.deltaY > 0 ? 1 : -1;
      if (cur >= lastLayerScroll - 10 && dir === 1) return;
      e.preventDefault();
      if (isScrolling) return;
      isScrolling = true;
      var target;
      if (dir === 1) target = (Math.round(cur / vh) + 1) * vh;
      else if (cur > lastLayerScroll + 10) target = lastLayerScroll;
      else target = (Math.round(cur / vh) - 1) * vh;
      if (target < 0) target = 0;
      if (target > maxScroll) target = maxScroll;
      window.scrollTo({ top: target, behavior: 'smooth' });
      setTimeout(function () { isScrolling = false; }, 400);
    }, { passive: false });
  }

  /* ================= LOOKBOOK ================= */
  var rawContent = document.getElementById('FengRawContent');
  var imageView = document.getElementById('FengImageView');
  if (rawContent && imageView) {
    var videoView = document.getElementById('FengVideoView');
    var viewToggle = document.getElementById('FengViewToggle');
    var btnImage = document.getElementById('BtnImage');
    var btnVideo = document.getElementById('BtnVideo');
    var btnMute = document.getElementById('BtnMuteToggle');
    rawContent.querySelectorAll('img').forEach(function (img) {
      img.src = img.src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048)\./i, '.');
      img.removeAttribute('width'); img.removeAttribute('height'); img.removeAttribute('srcset');
      imageView.appendChild(img);
    });
    if (videoView && videoView.querySelector('video') && viewToggle) viewToggle.classList.add('is-visible');
    if (btnMute) btnMute.addEventListener('click', function () {
      var muted = false;
      videoView.querySelectorAll('video').forEach(function (v) { v.muted = !v.muted; muted = v.muted; });
      this.innerText = muted ? 'UNMUTE' : 'MUTE';
    });
    if (btnImage && btnVideo) {
      btnImage.addEventListener('click', function () {
        btnImage.classList.add('is-active'); btnVideo.classList.remove('is-active');
        imageView.style.display = 'flex'; videoView.style.display = 'none';
        videoView.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
      btnVideo.addEventListener('click', function () {
        btnVideo.classList.add('is-active'); btnImage.classList.remove('is-active');
        imageView.style.display = 'none'; videoView.style.display = 'flex';
        videoView.querySelectorAll('video').forEach(function (v) { v.play(); });
      });
    }
    imageView.addEventListener('wheel', function (e) {
      if (window.innerWidth < 992) return;
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { e.preventDefault(); imageView.scrollLeft += e.deltaY * 1.5; }
    }, { passive: false });
  }
});

/* ================= GEO PRICE DISPLAY (ported from original site) ================= */
(function () {
  var USD_RATE = 25500;
  var COUNTRY_MAP = {
    VN: { cur: 'VND', sym: '' }, SG: { cur: 'SGD', sym: 'S$ ', rate: 1.35 }, US: { cur: 'USD', sym: '$', rate: 1.0 },
    GB: { cur: 'GBP', sym: '£', rate: 0.79 }, FR: { cur: 'EUR', sym: '€', rate: 0.92 }, DE: { cur: 'EUR', sym: '€', rate: 0.92 },
    IT: { cur: 'EUR', sym: '€', rate: 0.92 }, ES: { cur: 'EUR', sym: '€', rate: 0.92 }, NL: { cur: 'EUR', sym: '€', rate: 0.92 },
    JP: { cur: 'JPY', sym: '¥', rate: 155.0 }, KR: { cur: 'KRW', sym: '₩', rate: 1380.0 }, CN: { cur: 'CNY', sym: '¥', rate: 7.25 },
    TW: { cur: 'TWD', sym: 'NT$ ', rate: 32.5 }, HK: { cur: 'HKD', sym: 'HK$ ', rate: 7.82 }, AU: { cur: 'AUD', sym: 'A$ ', rate: 1.52 },
    CA: { cur: 'CAD', sym: 'CA$ ', rate: 1.37 }, TH: { cur: 'THB', sym: '฿', rate: 36.5 }, AE: { cur: 'AED', sym: 'AED ', rate: 3.67 }
  };
  function formatNumber(n) { return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function convertPrice(raw, info) {
    if (!raw || isNaN(raw) || raw <= 0) return '';
    if (info.cur === 'VND') return formatNumber(raw) + ' VND';
    var usd = Math.round(raw / USD_RATE);
    if (info.cur === 'USD') return '$' + formatNumber(usd) + ' USD';
    return (info.sym || '') + formatNumber(Math.round(usd * (info.rate || 1))) + ' ' + info.cur;
  }
  var isUpdating = false;
  function applyGeoPrices(info) {
    if (isUpdating) return;
    isUpdating = true;
    document.querySelectorAll('#FengProductPrice, .feng-pdp-price, .feng-erd-product-price, .feng-cart-price, .feng-rv-product-price, .product-price').forEach(function (el) {
      if (el.getAttribute('data-geo-applied') === info.cur) return;
      if (!el.getAttribute('data-base-price')) {
        var raw = parseInt((el.innerText || el.textContent).replace(/[^0-9]/g, ''), 10);
        if (raw && raw > 1000) el.setAttribute('data-base-price', raw);
      }
      var base = parseInt(el.getAttribute('data-base-price'), 10);
      if (base) { el.textContent = convertPrice(base, info); el.setAttribute('data-geo-applied', info.cur); }
    });
    applyKachingGeo(info); setTimeout(function () { isUpdating = false; }, 50);
  }
  function applyKachingGeo(info) { if (info.cur === 'VND') return; document.querySelectorAll('kaching-bundles-block *').forEach(function (el) { el.childNodes.forEach(function (n) { if (n.nodeType === 3 && /₫/.test(n.textContent)) { n.textContent = n.textContent.replace(/[\d.,]+\s*₫/g, function (m) { var r = parseInt(m.replace(/[^0-9]/g, ''), 10); return r ? convertPrice(r, info) : m; }); } }); }); } /* Kaching bundle widget geo prices */ async function getCountry() {
    var p = new URLSearchParams(window.location.search);
    var urlGeo = p.get('country') || p.get('geo');
    if (urlGeo) { sessionStorage.setItem('feng_cached_country', urlGeo.toUpperCase()); return urlGeo.toUpperCase(); }
    var cached = sessionStorage.getItem('feng_cached_country');
    if (cached) return cached;
    try {
      var c = new AbortController();
      setTimeout(function () { c.abort(); }, 1200);
      var res = await fetch('https://api.country.is/', { signal: c.signal });
      var data = await res.json();
      if (data && data.country) { sessionStorage.setItem('feng_cached_country', data.country.toUpperCase()); return data.country.toUpperCase(); }
    } catch (e) {}
    return 'VN';
  }
  async function init() {
    if (!window.FengGeoPrices) return;
    var code = await getCountry();
    var info = COUNTRY_MAP[code] || { cur: 'USD', sym: '$', rate: 1.0 };
    applyGeoPrices(info);
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { applyGeoPrices(info); }, 150); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
